import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/app/components/ApartmentCalculator.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path1/node_modules/next/dist/client/legacy/image.js");
